import { createScreenStyles } from '../../theme/styles';
import { OPERATIONS_API_BASE } from '../../config/api';
import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  StyleSheet,
  TouchableHighlight,
  Dimensions,
  ActivityIndicator,
  TextInput,
  Modal,
  Platform
} from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Entypo } from '@expo/vector-icons';
const screenWidth = Math.round(Dimensions.get("window").width);
const screenHeight = Math.round(Dimensions.get("window").height);

export function isIphoneX() {
  return Platform.OS === "ios" && screenHeight >= 812;
}

export function isAndroid() {
  return Platform.OS !== "ios";
}

export default function checklist({ route, navigation }) {

  const {checkId} = route.params;
  const [userid, setUserid] = useState('');
  const [usernome, setUsernome] = useState('');
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState("");
  const [commentsExit, setCommentsExit] = useState("");
  const [status, setStatus] = useState("");
  const [statusExit, setStatusExit] = useState("");
  const [status_comm, setStatus_comm] = useState('');
  const [docs, setDocs] = useState([]);
  const [itens, setItens] = useState([]);
  const [dialog, setDialog] = useState(null);

  // Modal próprio funciona no navegador e também no aplicativo nativo.
  function showDialog(title, message, buttons = [{ text: 'Entendi' }], options = {}) {
    setDialog({ title, message, buttons, cancelable: options.cancelable !== false });
  }

  function handleDialogButton(button) {
    setDialog(null);
    if (button && typeof button.onPress === 'function') {
      button.onPress();
    }
  }

  const { type } = route.params;

  async function getStorageValue() {
    setUserid(await AsyncStorage.getItem('sfuserid'));
    setUsernome(await AsyncStorage.getItem('sfusernome'));
  }
  
  async function loadItens() {
    let response;
    if(type === 0){
      response = await fetch(
        `${OPERATIONS_API_BASE}/checklistcompitem/checklist/` + checkId
      );
    } else {
      response = await fetch(
        `${OPERATIONS_API_BASE}/checklistcompitemexit/checklist/` + checkId
      );
    }

    const data = await response.json();
    setItens(data);
    setLoading(false);
  };

  async function loadHeader() {
    const response = await fetch(
      `${OPERATIONS_API_BASE}/checklistcomp/` + checkId
    );

    const data = await response.json();
    setDocs(data);
    setStatus(data[0].status);
    setStatusExit(data[0].statusExit);
    setComments(data[0].comentarios);
    setCommentsExit(data[0].comentariosExit);
    if(data[0].status_comm)
      setStatus_comm(data[0].status_comm);
  };

  async function save(){
    const sUrl = type === 0
      ? `${OPERATIONS_API_BASE}/checklistcompitem/checklist/`
      : `${OPERATIONS_API_BASE}/checklistcompitemexit/checklist/`;

    let data;
    try {
      const response = await fetch(sUrl + checkId);
      if (!response.ok) {
        throw new Error('Não foi possível carregar os itens do checklist.');
      }
      data = await response.json();
    } catch (error) {
      showDialog(
        'Não foi possível verificar',
        'Não foi possível validar os itens deste checklist. Verifique sua conexão e tente novamente.',
        [{ text: 'Entendi' }],
        { cancelable: true }
      );
      return;
    }

    if (!Array.isArray(data) || data.length === 0) {
      showDialog(
        'Checklist incompleto',
        'Não foi possível verificar os itens deste checklist. Recarregue e tente novamente.',
        [{ text: 'Entendi' }],
        { cancelable: true }
      );
      return;
    }

    // Primeiro valida todas as avaliações, para avisar sobre a pendência correta.
    for (let i = 0; i < data.length; i++) {
      if (data[i].avaliacao === undefined || data[i].avaliacao === null || data[i].avaliacao === '') {
        validaChecklist(data[i].ordemitem, data[i].nomeitem, 'avaliação');
        return;
      }
    }

    // Os quatro primeiros itens exigem foto; os demais exigem foto quando avaliação = 1.
    for (let i = 0; i < data.length; i++) {
      const fotoObrigatoria = i < 4 || Number(data[i].avaliacao) === 1;
      const temFoto = typeof data[i].foto === 'string' && data[i].foto.trim().length > 0;
      if (fotoObrigatoria && !temFoto) {
        validaChecklist(data[i].ordemitem, data[i].nomeitem, 'foto');
        return;
      }
    }

    showDialog(
      'Atenção',
      'Você confirma o envio do Checklist para aprovação ?',
      [
        { text: 'Cancelar' },
        { text: 'Sim', onPress: () => confirmSubmit() }
      ],
      { cancelable: true }
    );
  };

  function validaChecklist(ordemitem, nomeitem, tipo){
    const mensagem = tipo === 'foto'
      ? 'O checklist ainda possui fotos pendentes. Envie todas as fotos necessárias antes de finalizar o checklist.'
      : 'O checklist ainda possui itens pendentes de avaliação. Conclua todas as avaliações antes de finalizar o checklist.';

    showDialog(
      'Checklist incompleto',
      mensagem,
      [{ text: 'Entendi' }],
      { cancelable: true }
    );
  };

  async function confirmSubmit(){
    let objPut = {};
    
    if(type === 0){
      objPut = {      
        status: 1,
        idusuario: userid,
        nomeusuario: usernome,
        comentarios: comments,
        status_comm: ''
      };
    } else {
      objPut = {      
        statusExit: 1,
        idusuarioExit: userid,
        nomeusuarioExit: usernome,
        comentariosExit: commentsExit,
        status_comm: ''
      };
    }

    const responsePut = await fetch(
      `${OPERATIONS_API_BASE}/checklistcomp/` + checkId,
      //  'http://192.168.0.8:8080/checklistcomp/' + checkId,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(objPut),
      }
    );
  
    let dataPut = {};
    try {
      dataPut = await responsePut.json();
    } catch (error) {
      dataPut = {};
    }
  
    if (responsePut.ok) {
      showDialog(
        "Sucesso",
        "Checklist enviado com sucesso !",
        [
          {
            text: "Fechar",
            style: "cancel",
            onPress: () => navigation.navigate('CompPreIndexType')
          },
        ],
        { cancelable: false }
      );
    } else if (dataPut && dataPut.code === 'CHECKLIST_INCOMPLETO') {
      showDialog(
        'Checklist incompleto',
        dataPut.message || 'O checklist possui itens pendentes. Conclua as avaliações e envie as fotos necessárias antes de finalizar.',
        [{ text: 'Entendi' }],
        { cancelable: true }
      );
    } else {
      showDialog(
        'Não foi possível enviar',
        (dataPut && dataPut.message) || 'O checklist não foi enviado. Verifique sua conexão e tente novamente.',
        [{ text: 'Entendi' }],
        { cancelable: true }
      );
    }
      
  }

  useEffect(() => {
    setLoading(true);
    loadHeader();
    loadItens();
    getStorageValue();
  }, []);   
    
  return (
  <KeyboardAvoidingView
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      style={styles.container}
    >
      <ScrollView>
      {loading && (
            <ActivityIndicator size="large" color="#0000ff" style={styles.LoadingIndicator} />
          ) 
      }
      {docs.map(docs => 
          <View key={docs._id}>
            <View style={styles.headerContainer}>        
              <Text numberOfLines={1} style={styles.textDescBold2}>Informações do Cliente</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Nome: </Text>{docs.idcliente.nome}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Cidade/UF: </Text>{docs.idcliente.cidade} - {docs.idcliente.uf}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Garantia: </Text>{docs.garantia == 1 ? "Sim" + " / OS:(" + docs.osgarantia + ")":"Não"}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Status Entrada: </Text>{docs.status == '0' ? "Pendente" : docs.status == '1' ? "Processando" : "Concluído"}</Text>
              {docs.statusExit &&
                <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Status Saída: </Text>{docs.statusExit == '0' ? "Pendente" : docs.statusExit == '1' ? "Processando" : "Concluído"}</Text>
              }
            </View>
            
        
            <View style={styles.headerContainer}>
              <Text numberOfLines={1} style={styles.textDescBold2}>Informações do Compressor</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>OS: </Text>{docs.nos}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Data de Entrada: </Text>{docs.dataentrada.substring(8,10) + "/" + docs.dataentrada.substring(5,7) + "/" + docs.dataentrada.substring(0,4)}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Fabricante: </Text>{docs.idfabricante.nome}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Modelo: </Text>{docs.idcompressor.modelo}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Tensão: </Text>{docs.tensao}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Gás: </Text>{docs.gas}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Número de Série: </Text>{docs.nserie}</Text>
              <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Número de Ativo: </Text>{docs.nativo}</Text>
            </View>
          </View>
     )}

      {status_comm != '' && status == '0' &&
        <View style={styles.headerContainer}>  
          <Text style={styles.textDesc}><Text style={styles.textDescBold}>Rejeitado: </Text>{status_comm}</Text>
        </View>
      }

      {itens.map(itens => 
          <TouchableHighlight
          underlayColor={"#a5a5a5"}
          style={styles.highlight}
          key={itens._id}
          onPress={() => {navigation.navigate("Avaliar", { nomeitem: itens.nomeitem, iditem: itens._id, fab: docs[0].idfabricante.nome, mod: docs[0].idcompressor.modelo, status:docs[0].status , type: type , statusExit: docs[0].statusExit ,refresh: loadItens}) }}>
          
          <View style={styles.containerGeral}>
            <View style={styles.txtContainerRow}>
              
              <View style={styles.divCounter}>
                <Text numberOfLines={1} style={styles.textDescBold}>{itens.ordemitem}</Text>
              </View>

              <View style={styles.divMiddle}>
                <Text numberOfLines={1} style={styles.textDescBold}>{itens.nomeitem}</Text>
                <Text numberOfLines={1} style={itens.avaliacao == null ? styles.textDescPend : styles.textDescOk}>{itens.avaliacao == null ? "Pendente Avaliação" : "Item Avaliado"}</Text>
                { itens.ordemitem == 1 &&
                <Text numberOfLines={1} style={itens.foto == null ? styles.textDescPend : styles.textDescOk}>{itens.foto == null ? "Pendente Foto" : "Foto Salva"}</Text>
                }
                { itens.ordemitem == 2 &&
                <Text numberOfLines={1} style={itens.foto == null ? styles.textDescPend : styles.textDescOk}>{itens.foto == null ? "Pendente Foto" : "Foto Salva"}</Text>
                }
                { itens.ordemitem == 3 &&
                <Text numberOfLines={1} style={itens.foto == null ? styles.textDescPend : styles.textDescOk}>{itens.foto == null ? "Pendente Foto" : "Foto Salva"}</Text>
                }
                { itens.ordemitem == 4 &&
                <Text numberOfLines={1} style={itens.foto == null ? styles.textDescPend : styles.textDescOk}>{itens.foto == null ? "Pendente Foto" : "Foto Salva"}</Text>
                }
              </View>

              <View style={styles.divIcon}>
              <Entypo name={'chevron-right'} style={styles.searchIconReset} size={18} color="#b2b2b2" />  
              </View>

            </View>
          </View>
        </TouchableHighlight>
      )}

    <Text style={styles.textDescBoldObs}>Observação Entrada:</Text>

      <TextInput
        style={styles.textSearch}
        placeholder={status < 1 ? "Digite suas observações": ""}
        placeholderTextColor="#484848"
        maxLength={200}
        autoCorrect={false}
        editable={status < 1}
        multiline={true}
        autoCapitalize="sentences"
        value={comments}
        onChangeText={setComments}
      />

      { type === 1 &&
        <>
          <Text style={styles.textDescBoldObs}>Observação Saída:</Text>

          <TextInput
            style={styles.textSearch}
            placeholder={statusExit < 1 ? "Digite suas observações": ""}
            placeholderTextColor="#484848"
            maxLength={200}
            autoCorrect={false}
            editable={statusExit < 1}
            multiline={true}
            autoCapitalize="sentences"
            value={commentsExit}
            onChangeText={setCommentsExit}
          />
        </>
      }
      {((type === 0 && status < 1) || (type === 1 && statusExit < 1)) && 
        <TouchableHighlight
          underlayColor={"#fff"}
          style={styles.headerContainer}
          onPress={() => save()}
        >
       
          <View style={styles.buttonDoneBig}>
            <Text style={styles.buttonText}>Enviar Checklist</Text>
          </View>

        </TouchableHighlight>
      }
      <View>
      <Text></Text>
      <Text></Text>
      </View>
    

      </ScrollView>

      <Modal
        transparent
        visible={!!dialog}
        animationType="fade"
        onRequestClose={() => {
          if (dialog && dialog.cancelable) setDialog(null);
        }}
      >
        <View style={styles.dialogOverlay}>
          <View style={styles.dialogCard}>
            <Text style={styles.dialogTitle}>{dialog ? dialog.title : ''}</Text>
            <Text style={styles.dialogMessage}>{dialog ? dialog.message : ''}</Text>
            <View style={styles.dialogButtons}>
              {dialog && dialog.buttons.map((button, index) => (
                <TouchableHighlight
                  key={`${button.text}-${index}`}
                  underlayColor={button.text === 'Cancelar' ? '#e2e2e2' : '#285228'}
                  style={styles.dialogButtonWrapper}
                  onPress={() => handleDialogButton(button)}
                >
                  <View style={[
                    styles.dialogButton,
                    button.text === 'Cancelar' ? styles.dialogButtonSecondary : styles.dialogButtonPrimary
                  ]}>
                    <Text style={[
                      styles.dialogButtonText,
                      button.text === 'Cancelar' ? styles.dialogButtonTextSecondary : styles.dialogButtonTextPrimary
                    ]}>{button.text}</Text>
                  </View>
                </TouchableHighlight>
              ))}
            </View>
          </View>
        </View>
      </Modal>
    </KeyboardAvoidingView>

    // <View style={styles.container}>

    //     <View style={styles.containerGeral}>

    //       {/* <TextInput
    //           style={styles.textSearch}
    //           placeholder='Digite suas observações'
    //           placeholderTextColor="gray"
    //           maxLength={200}
    //           multiline={true}
    //           autoCapitalize='sentences'
    //           value={comments}
    //           onChangeText={setComments}
    //         /> */}

    //       {/* <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('Camera') }}>
    //         <View style={styles.menuItem}>
    //           <Text style={styles.textMenu}>Adicionar Foto</Text>
    //         </View>
    //       </TouchableHighlight>

    //       <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('Checklist2Compressor') }}>
    //         <View style={styles.menuItem}>
    //           <Text style={styles.textMenu}>Próximo Item</Text>
    //         </View>
    //       </TouchableHighlight> */}

    //     </View>

    // </View>
  );
}

var styles = createScreenStyles({
  container: {
    flex: 1,
    backgroundColor: "#d5d5d5",
  },

  LoadingIndicator: {
    flex: 1,
    justifyContent: "center",
    marginTop: 15,
  },

  ItemImg: {
    backgroundColor: "#fff",
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 4,
    marginLeft: screenWidth * 0.025,
    marginRight: screenWidth * 0.025,
  },

  menuItem: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "green",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemG: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "green",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemY: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "#CC6600",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemR: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "red",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  textDescPend: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#fa9200'
  },

  textDescOk: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#4ead31'
  },


  textMenu: {
    color: "#fff",
    fontSize: 16,
  },

  textSearch: {
    width: '97%',
    paddingLeft: 10,
    marginLeft:5,
    color: "#484848",
    height: 100,
    marginTop: screenHeight * 0.01,
    marginBottom: screenHeight * 0.01,
    backgroundColor: "#fff",
    borderColor: "#d3d3d3",
    borderWidth: 1,
    borderRadius: 5,
  },

  textEmpty: {
    fontSize: 14,
    fontWeight: "300",
    color: "#484848",
    marginLeft: screenWidth * 0.025,
    marginTop: 10,
    textAlign: "center",
  },

  textDesc: {
    fontSize: 14,
    paddingTop: 5,
  },

  textDescBold: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
  },

  textDescBoldObs: {
    fontSize: 14,
    paddingTop: 15,
    fontWeight: "bold",
    paddingLeft: 10,
  },

  textDescBold2: {
    fontSize: 14,
    marginBottom:5,
    fontWeight: "bold",
    textAlign:'center'
  },

  textDescBold3: {
    fontSize: 15,
    marginBottom:5,
    fontWeight: "bold",
    textAlign:'center',
    color:'#484848'
  },

  textDescAberto: {
    fontSize: 12,
    paddingTop: 5,
    color: "green",
  },

  containerGeral: {
    backgroundColor: "#fff",
    paddingLeft: 10,
    paddingBottom: 10,
    borderRadius: 3,
  },

  txtContainer: {
    width: '90%',
    marginTop: 5,
  },


  txtContainerRow: {
    flexDirection:'row',
    marginTop: 5,
  },

  headerContainerInt:{
    marginTop:5,
    marginLeft:5,
    marginRight:5,
    padding:10
  },

  headerContainer:{
    backgroundColor:'#fff',
    marginTop:5,
    marginLeft:5,
    marginRight:5,
    padding:10
  },

  highlight: {
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    borderWidth:1,
    borderColor:'#999999'

  },

  buttonDoneBig:{
    backgroundColor:'#336633',
    marginTop: 5,
    height:60,
    width: '90%',
    justifyContent:'center',
    borderRadius:10
  },

  buttonDone:{
    backgroundColor:'#336633',
    marginTop: 5,
    height:30,
    width: '90%',
    justifyContent:'center'
  },

  buttonPend:{
    backgroundColor:'#993333',
    marginTop: 5,
    height:30,
    width: '90%',
    justifyContent:'center'
  },

  buttonText:{
    textAlign:'center',
    color:'#fff'
  },


  divCounter:{
    width: '7%',
    justifyContent:'center',
    borderRightWidth:1,
    borderRightColor:'#a1a1a1'
  },

  divMiddle:{
    width: '72%',
    borderRightWidth:1,
    borderRightColor:'#a1a1a1',
    paddingLeft:10
  },

  divIcon:{
    width: '10%',
    justifyContent:'center',
    alignSelf:'center',
    alignItems:'center'
  },

  dialogOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24
  },

  dialogCard: {
    width: '100%',
    maxWidth: 420,
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 22,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 8
  },

  dialogTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#222222',
    marginBottom: 12
  },

  dialogMessage: {
    fontSize: 15,
    lineHeight: 22,
    color: '#484848'
  },

  dialogButtons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    marginTop: 22
  },

  dialogButtonWrapper: {
    marginLeft: 8,
    marginTop: 6,
    borderRadius: 7,
    overflow: 'hidden'
  },

  dialogButton: {
    minWidth: 88,
    paddingHorizontal: 16,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 7
  },

  dialogButtonPrimary: {
    backgroundColor: '#336633'
  },

  dialogButtonSecondary: {
    backgroundColor: '#eeeeee',
    borderWidth: 1,
    borderColor: '#cccccc'
  },

  dialogButtonText: {
    fontSize: 14,
    fontWeight: '600'
  },

  dialogButtonTextPrimary: {
    color: '#ffffff'
  },

  dialogButtonTextSecondary: {
    color: '#333333'
  }


});
